module.exports = __webpack_public_path__ + "static/media/thumb.f60aa6a8.jpg";